import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getTransmissionState } from '../../thunks/vehicleProThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
import { clearVehicleProKey } from '../../thunkKeys/vehicleProThunksKeys';

const SLICE_NAME = 'transmissionState';

export const transmissionStateSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTransmissionState(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTransmissionState });
        builder.addCase(
            clearVehicleProKey,
            () => commonInitialState,
        );
    },
});

export const { clearTransmissionState } = transmissionStateSlice.actions;

export const transmissionState = transmissionStateSlice.reducer;
